import axios from './request/http' // 导入http中创建的axios实例
import qs from 'qs' // 根据需求是否导入qs模块
import baseUrl from './base' // 导入接口域名列表
import apiList from './apiList' // 导入接口名称列表
import * as Data from '../data'

function transformObjectToUrlencodedData(obj) {
    let p = []
    for (let key in obj) {
        // eslint-disable-next-line no-prototype-builtins
        if (obj.hasOwnProperty(key)) {
            p.push(encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]))
        }
    }
    return p.join('&')
}

function _post(api, ...args) {
    let requestArr = {}
    requestArr.token = Data.getToken()
    for (let i = 1; i < api.length; i++) {
        let param = args[i - 1]
        param = (param === undefined || param === null) ? '' : param
        requestArr[api[i]] = param
    }
    console.info(`${api[0]} ==> ${baseUrl}/${api[0]}?${transformObjectToUrlencodedData(requestArr)}`)
    return axios.post(`${baseUrl}/${api[0]}`, qs.stringify(requestArr))
}

function Api() {
    function generateApi() {
        let API = this
        for (let moduleKey in apiList) {
            let moduleName = apiList[moduleKey]
            API[moduleKey] = {}
            for (let functionName in moduleName) {
                let config = moduleName[functionName]
                API[moduleKey][functionName] = ((config) => {
                    return (...data) => {
                        return _post(config, ...data)
                    }
                })(config)
            }
        }
    }
    generateApi.call(this)
}

export default new Api()
